function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
import { datadogLogs } from '@datadog/browser-logs';
import { getEnvironment, NODE_PROCESS_ENVIRONMENT } from "../../../common";
import { ScribeLoggerPlugin } from "./models/ScribeLoggerPlugin";
var didInit = false;
var PLUGIN_ID = ScribeLoggerPlugin.generatePluginId();

/**
 * Represents a third-party integration plugin for logging with DataDog.
 *
 * @extends ScribeLoggerPlugin
 */
var _pushLogToDataDog = /*#__PURE__*/new WeakSet();
export var ThirdPartyIntegrationPlugin = /*#__PURE__*/function (_ScribeLoggerPlugin) {
  _inherits(ThirdPartyIntegrationPlugin, _ScribeLoggerPlugin);
  var _super = _createSuper(ThirdPartyIntegrationPlugin);
  function ThirdPartyIntegrationPlugin(opts) {
    var _opts$clientToken, _opts$service, _opts$site;
    var _this;
    _classCallCheck(this, ThirdPartyIntegrationPlugin);
    _this = _super.call(this);
    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _pushLogToDataDog);
    _defineProperty(_assertThisInitialized(_this), "id", PLUGIN_ID);
    if (typeof process === 'undefined') {
      return _possibleConstructorReturn(_this);
    }
    var clientToken = (_opts$clientToken = opts === null || opts === void 0 ? void 0 : opts.clientToken) !== null && _opts$clientToken !== void 0 ? _opts$clientToken : process.env.DATA_DOG_CLIENT_TOKEN;
    var serviceName = (_opts$service = opts === null || opts === void 0 ? void 0 : opts.service) !== null && _opts$service !== void 0 ? _opts$service : process.env.DATA_DOG_SERVICE_NAME;
    var siteName = (_opts$site = opts === null || opts === void 0 ? void 0 : opts.site) !== null && _opts$site !== void 0 ? _opts$site : process.env.DATA_DOG_SITE;
    var shouldInitializeDataDog = Boolean(NODE_PROCESS_ENVIRONMENT === 'production' && clientToken && serviceName && siteName);
    if (shouldInitializeDataDog) {
      datadogLogs.init(_objectSpread({
        env: getEnvironment(),
        clientToken: clientToken,
        service: serviceName,
        site: siteName,
        sessionSampleRate: 100,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error']
      }, opts));
      datadogLogs.onReady(function () {
        didInit = true;
      });
    }
    return _this;
  }
  _createClass(ThirdPartyIntegrationPlugin, [{
    key: "processLog",
    value: function processLog(level, msg) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      if (didInit) {
        var _classPrivateMethodGe;
        (_classPrivateMethodGe = _classPrivateMethodGet(this, _pushLogToDataDog, _pushLogToDataDog2)).call.apply(_classPrivateMethodGe, [this, level, msg].concat(args));
      }
      return [level, msg, args];
    }
  }]);
  return ThirdPartyIntegrationPlugin;
}(ScribeLoggerPlugin);
function _pushLogToDataDog2(level, msg) {
  if (level === 'log') return;
  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }
  var payload = args.length === 1 ? {
    args: args[0]
  } : {
    args: args
  };
  switch (level) {
    case 'info':
      datadogLogs.logger.info(msg, payload);
      break;
    case 'warn':
      datadogLogs.logger.warn(msg, payload);
      break;
    case 'error':
      datadogLogs.logger.error(msg, payload);
      break;
    case 'debug':
      datadogLogs.logger.debug(msg, payload);
      break;
    default:
      datadogLogs.logger.log(msg, payload);
      break;
  }
}